export default "__VITE_ASSET__CEMsdp6w__"